export type OrderStatus = 'active' | 'paused' | 'completed'

export interface Order {
  id: string
  chargenNummer: string
  produktName: string
  produktNr: string
  status: OrderStatus
  linie: string
  sollgewicht: string
  prueflingeGeprueft: number
  avgTemperature: number
  avgWeight: number
  lastInspection: Date
  nextInspection: Date
  startedAt: Date
  completedAt?: Date
}

export function getNextInspectionTime(lastInspection: Date): Date {
  const next = new Date(lastInspection)
  next.setMinutes(next.getMinutes() + 30)
  return next
}

export function getTimeUntilNextInspection(nextInspection: Date): string {
  const now = new Date()
  const diff = nextInspection.getTime() - now.getTime()

  if (diff <= 0) return 'Überfällig'

  const minutes = Math.floor(diff / 60000)
  const seconds = Math.floor((diff % 60000) / 1000)

  if (minutes > 0) {
    return `${minutes} Min`
  }
  return `${seconds} Sek`
}

export function getStatusColor(status: OrderStatus): string {
  switch (status) {
    case 'active':
      return 'blue'
    case 'paused':
      return 'yellow'
    case 'completed':
      return 'green'
  }
}

export function getStatusLabel(status: OrderStatus): string {
  switch (status) {
    case 'active':
      return 'Aktiv'
    case 'paused':
      return 'Pausiert'
    case 'completed':
      return 'Abgeschlossen'
  }
}
